import styled from 'styled-components'
import { motion } from 'framer-motion'

export const Body = styled.div`
  overflow: hidden;
`

export const Collapse = styled(motion.div)`
  overflow: hidden;
`

export const Heading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`

export const Item = styled.div``

export const Wrapper = styled.div`
  position: relative;
`
